import { z } from "zod";

export const postFileAnnotationsSchema = z.object({
	annotations: z.array(z.any()),
});

export type PostFileAnnotationsSchema = z.infer<typeof postFileAnnotationsSchema>;
